import React from 'react';
import { Flex, Box } from 'rebass';
import NavCell from '../components/navcell'

import styled from 'styled-components';
import { Controller, Scene } from 'react-scrollmagic';

import IotBraces from '../components/term/braces';
import EscapeEd from '../components/term/ed';
import FrostyKeypad from '../components/term/keypad'
import LinuxPath from '../components/term/path'
import NyanShell from '../components/term/nyan'
import MongoPilfer from '../components/term/mongo'
import HolidayTrail from '../components/term/hht'
import IRGraylog from '../components/term/graylog'
import XmasLaser from '../components/term/laser'
import ZeekLogs from '../components/term/zeek'



const ClassToggleStyled = styled.div`
  .active {
    background-color: #2e3440;
    color: white;
  }
  .section {
    height: 100vh;
  }
  img {
    margin: 0; !important
  }

  .test {
	  transition: width 0.3s ease-out;
	  width: 100px;
    height: 100px;
    background-color: red;
    margin: 0 !important;

    &.yellow {
      background-color: yellow;
    }
  }
  .zap {
    width: 100%;
  }
  .sticky {
    background-color: red;
    width: 100%;
  }
`;

const Nav = () => {
  return (
    <Flex
      id='terminals'
      fontSize={[ 1, 2 ]}
      fontWeight='700'
      flexDirection='column'
      height='70vh'
      alignSelf='end'
      alignItems='center'
      justifyContent='space-evenly'
    >
      <NavCell text='Ed' nav='a' />
      <NavCell text='Braces' nav='b' />
      <NavCell text='Keypad' nav='c' />
      <NavCell text='Path' nav='d' />
      <NavCell text='Nyan' nav='e' />
      <NavCell text='Mongo' nav='f' />
      <NavCell text='Trail' nav='g' />
      <NavCell text='Graylg' nav='h' />
      <NavCell text='Laser' nav='i' />
      <NavCell text='Zeek' nav='j' />
    </Flex>
  )
}

const Terminals = () => {
  const getHeight = (id) => {
    return window.getComputedStyle(document.getElementById(id)).height.slice(0,-2) - 3
  }
  return(
  <Flex fontFamily='Roboto' width='100%' >
    <div id="section" />
    <Box width={['20vw', '10vw']}>
    <ClassToggleStyled>
      <div id="trigg" />
      <Controller >
        <Scene duration={28700} pin triggerElement="#trigg" triggerHook="0.3" indicators={false}>
         <div>
          <Nav />
         </div>
        </Scene>
      </Controller>
    </ClassToggleStyled>
    </Box>

    <Flex
      id='tt'
      flexDirection="column"
      width={['80vw', '85vw']}
      mx={['3vw', '6vw']}
    >
    <Controller >
      <Scene duration={() => getHeight('a')} triggerHook="onLeave" classToggle={['#nav_a', 'active']} indicators={false}>
        <Box id='a' >
         <EscapeEd />
        </Box>
      </Scene>

      <Scene duration={() => getHeight('b')} triggerHook="onLeave" classToggle={['#nav_b', 'active']} indicators={false}>
        <Box id='b'  >
         <IotBraces />
        </Box>
      </Scene>

      <Scene duration={() => getHeight('c')} triggerHook="onLeave" classToggle={['#nav_c', 'active']} indicators={false}>
        <Box id='c' >
          <FrostyKeypad />
        </Box>
      </Scene>

      <Scene duration={() => getHeight('d')} triggerHook="onLeave" classToggle={['#nav_d', 'active']} indicators={false}>
        <Box id='d' >
         <LinuxPath />
        </Box>
      </Scene>

      <Scene duration={() => getHeight('e')} triggerHook="onLeave" classToggle={['#nav_e', 'active']} indicators={false}>
        <Box id='e' >
         <NyanShell />
        </Box>
      </Scene>

      <Scene duration={() => getHeight('f')} triggerHook="onLeave" classToggle={['#nav_f', 'active']} indicators={false}>
        <Box id='f' >
         <MongoPilfer />
        </Box>
      </Scene>

      <Scene duration={() => getHeight('g')} triggerHook="onLeave" classToggle={['#nav_g', 'active']} indicators={false}>
        <Box id='g'  >
         <HolidayTrail />
        </Box>
      </Scene>

      <Scene duration={() => getHeight('h')} triggerHook="onLeave" classToggle={['#nav_h', 'active']} indicators={false}>
        <Box id='h' >
         <IRGraylog />
        </Box>
      </Scene>

      <Scene duration={() => getHeight('i')} triggerHook="onLeave" classToggle={['#nav_i', 'active']} indicators={false}>
        <Box id='i' >
         <XmasLaser />
        </Box>
      </Scene>

      <Scene duration={() => getHeight('j')} triggerHook="onLeave" classToggle={['#nav_j', 'active']} indicators={false}>
        <Box id='j' >
         <ZeekLogs />
        </Box>
      </Scene>

    </Controller>
    </Flex>

  </Flex>
);
}

export default Terminals;
